import React, { useState } from 'react';
import { useMedia } from '@qover/hooks';
import TinyPopover, { PopoverProps } from 'react-tiny-popover';
import { InfoIcon } from './Icons';
import { Container } from './tooltip.styles';

export type CustomTooltipProps = {
  button?: React.ReactElement;
  containerClassName?: string;
  position?: PopoverProps['position'];
};

function Tooltip({
  button = <InfoIcon />,
  children,
  containerClassName,
  position = ['right', 'top', 'bottom', 'left'],
}: React.PropsWithChildren<CustomTooltipProps>) {
  const isMobile = useMedia(['(max-width: 767px)'], [true], false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Container
      className={containerClassName}
      onClick={() => isMobile && setIsPopoverOpen(!isPopoverOpen)}
      onMouseEnter={() => !isMobile && setIsPopoverOpen(true)}
      onMouseLeave={() => !isMobile && setIsPopoverOpen(false)}
    >
      <TinyPopover
        containerClassName="tooltip"
        content={children as React.ReactElement}
        isOpen={isPopoverOpen}
        onClickOutside={() => isMobile && setIsPopoverOpen(false)}
        position={position}
      >
        {ref => React.cloneElement(button, { ref })}
      </TinyPopover>
    </Container>
  );
}

export default Tooltip;
